import { render, staticRenderFns } from "./SettingPhoto.vue?vue&type=template&id=20b7b151&scoped=true"
import script from "./SettingPhoto.vue?vue&type=script&lang=js"
export * from "./SettingPhoto.vue?vue&type=script&lang=js"
import style0 from "./SettingPhoto.vue?vue&type=style&index=0&id=20b7b151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b7b151",
  null
  
)

export default component.exports